import React from "react";
import { TitleHolder } from "../../common/sharedComponents/styles/card.style";
import { StepperContentHolder } from "../vendorRegistration/vendorRegistration";
import OfficerCreateVendorContent from "./components/OfficerCreateVendorContent";

const OfficerCreateVendor = () => {
  return (
    <div>
      <TitleHolder>Vendor Registration by Officer</TitleHolder>
      <StepperContentHolder>
        <OfficerCreateVendorContent />
      </StepperContentHolder>
    </div>
  );
};

export default OfficerCreateVendor;
